import { Building2, Factory, Truck, Home, Droplets } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const DeploymentsSection = () => {
  const { t } = useLanguage();

  const deployments = [
    {
      title: t('deployments.cities'),
      description: t('deployments.citiesDesc'),
      icon: Building2,
    },
    {
      title: t('deployments.utilities'),
      description: t('deployments.utilitiesDesc'),
      icon: Droplets,
    },
    {
      title: t('deployments.buildings'),
      description: t('deployments.buildingsDesc'),
      icon: Home,
    },
    {
      title: t('deployments.logistics'),
      description: t('deployments.logisticsDesc'),
      icon: Truck,
    },
    {
      title: t('deployments.healthcare'),
      description: t('deployments.healthcareDesc'),
      icon: Factory,
    },
  ];

  return (
    <section id="industries" className="py-20 md:py-32 bg-slate-50" data-testid="deployments-section">
      <div className="container-0g">
        {/* Section Header */}
        <div className="mb-12 md:mb-16">
          <p className="section-label">{t('deployments.label')}</p>
          <h2 className="section-title mb-4">{t('deployments.title')}</h2>
          <p className="text-lg text-slate-600 max-w-2xl">
            {t('deployments.subtitle')}
          </p>
        </div>

        {/* Deployments Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {deployments.map((deployment, index) => {
            const Icon = deployment.icon;
            return (
              <div
                key={index}
                className="group p-6 border border-slate-200 hover:border-teal-500 transition-colors bg-white"
                data-testid={`deployment-${index}`}
              >
                {/* Icon */}
                <div className="deployment-icon w-14 h-14 rounded-sm flex items-center justify-center mb-4 group-hover:bg-teal-600 transition-colors">
                  <Icon className="h-7 w-7 text-slate-600 group-hover:text-white transition-colors" />
                </div>
                
                {/* Content */}
                <h3 className="text-lg font-semibold text-slate-900 mb-2">{deployment.title}</h3>
                <p className="text-sm text-slate-600">{deployment.description}</p>
              </div>
            );
          })}
        </div>

        {/* Trust statement */}
        <div className="mt-12 text-center">
          <p className="text-slate-500">
            <span className="font-semibold text-slate-900">{t('deployments.trustStatement')}</span>
            {' '}{t('deployments.trustStatementSub')}
          </p>
        </div>
      </div>
    </section>
  );
};
